// import { IOption } from 'components/Inputs/SelectComponent/types';

import { IValidation } from '@/types/common';

export const passwordPattern = {
  value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,8}$/,
  message: 'Password does not match requirements',
};
export const emailPattern = {
  value:
    /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  message: 'Введите правильный Email',
};
export const phonePattern = {
  value: /^[+]?\d{7,15}$/g,
  message: 'Phone not valid',
};
export const urlPattern = {
  value: /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gim,
  message: 'The URL you entered is invalid\n(URLs must start with http:// or https://)',
};

export const urlValidation = (): IValidation => {
  return {
    validate: (val: string) => {
      if (!val) return true;
      try {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const url = new URL(val);
        return true;
      } catch {
        return false;
      }
    },
    message: 'The URL you entered is invalid',
  };
};

// export const quantityValidation = (qty: number): IValidation => {
//   return {
//     validate: (val: IOption[]) => (val?.length || 0) <= qty,
//     message: 'Selected to many items',
//   };
// };
export const strLengthValidation = (length = 140): IValidation => {
  return {
    validate: (val: string) => (val?.length || 0) <= length,
    message: 'Value is too long',
  };
};
export const moneyInputValidation = (min: number, max: number): IValidation => {
  return {
    validate: (val: string) => {
      if (!val) return true;
      const strToNum = val?.toString().split('.')[0].match(/\d/g)?.join('');
      return !!(strToNum && +strToNum >= min && +strToNum <= max);
    },
    message: `Value must be between ${min} and ${max}`,
  };
};

export const passwordsMatchValidation = (condition: string): IValidation => {
  return {
    validate: (val: string) => val === condition,
    message: 'Passwords does not match',
  };
};
